import React from 'react';
import { List as MuiList, MenuItem } from '@material-ui/core';
var selectMenuHeight = 50;
var optionsShown = 4;
export var MenuListWeb = function MenuListWeb(props) {
  var options = props.options,
      _props$children = props.children,
      children = _props$children === void 0 ? [] : _props$children;
  var listSize = selectMenuHeight * Math.min(optionsShown, (options === null || options === void 0 ? void 0 : options.flatMap(function (e) {
    return e.options;
  }).length) || 1);
  var listStyle = {
    padding: 0,
    maxHeight: listSize,
    overflowY: (options === null || options === void 0 ? void 0 : options.flatMap(function (e) {
      return e.options;
    }).length) > 4 ? 'scroll' : 'hidden',
    overflowX: 'hidden'
  };
  var notFoundStyle = {
    height: selectMenuHeight
  }; // eslint-disable-next-line react/destructuring-assignment

  var labelNotFound = props.selectProps.labelNotFound;
  return /*#__PURE__*/React.createElement(MuiList, {
    style: listStyle
  }, Array.isArray(children) ? children.map(function (i) {
    return i;
  }) : /*#__PURE__*/React.createElement(MenuItem, {
    disabled: true,
    style: notFoundStyle
  }, labelNotFound));
};